class CartDrawer {
  constructor() {
    this.drawer = document.getElementById('CartDrawer');
    this.body = document.body;
    window.cartDrawerInstance = false;
    if(window.cartDrawerInstance != true){
        this.bindEvents();
    }
    console.log("Cart drawer loaded...");
  }

  bindEvents() {
    window.cartDrawerInstance = true;
    this.drawer.addEventListener('click', (e) => {
      if (e.target.closest('.cart_close_btn') || 
          e.target.closest('.skilk__overlay')) {
        this.close();
        return;
      }

      const removeBtn = e.target.closest('.cart_remove-btn');
      if (removeBtn) {
        const key = removeBtn.dataset.key;
        this.updateItem(key, 0);
        return;
      }

      const qtyBtn = e.target.closest('.qty-btn');
      if (qtyBtn) {

        const wrapper = qtyBtn.closest('.qty-wrapper');
        const qtyInput = wrapper.querySelector('.cart-item__qty');

        let currentQty = parseInt(qtyInput.value);
        const key = qtyInput.dataset.key;

        if (qtyBtn.dataset.type === 'plus') {
          currentQty += 1;
        }

        if (qtyBtn.dataset.type === 'minus') {
          currentQty = currentQty > 1 ? currentQty - 1 : 1;
        }

        qtyInput.value = currentQty;
        this.updateItem(key, currentQty);
      }

    });

    this.drawer.addEventListener('change', (e) => {

      if (e.target.matches('.cart-item__qty')) {
        const key = e.target.dataset.key;
        const qty = parseInt(e.target.value);
        this.updateItem(key, qty);
      }

    });
  }

  open() {
    this.drawer.classList.add('cart-drawer-active');
    this.body.classList.add('cart-drawer-open');
  }

close() {
    this.drawer.classList.remove('cart-drawer-active');
    this.body.classList.remove('cart-drawer-open');
    this.body.classList.remove('blocked-scroll');
    document.querySelectorAll('.cart_container').forEach(el => {
        el.classList.remove('active_link');
    });
}

  updateItem(key, quantity) {

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
    .then(() => this.render());
  }

  render() {

    fetch(window.location.pathname + '?sections=cart-drawer')
      .then(res => res.json())
      .then(data => {

        const parser = new DOMParser();
        const doc = parser.parseFromString(data['cart-drawer'], 'text/html');
        const newContent = doc.getElementById('CartDrawer').innerHTML;

        this.drawer.innerHTML = newContent;

        // UPDATE CART COUNT
        return fetch('/cart.js');
      })
      .then(res => res.json())
      .then(cart => {

        document.querySelectorAll('.cart_count').forEach(el => {
          el.textContent = cart.item_count;
        });

      });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  window.cartDrawer = new CartDrawer();
});

window.CartOpenCallbackFunction = function(){
  window.cartDrawer.render();
  window.cartDrawer.open();
};

document.addEventListener('click', function(e) {
  const cartLink = e.target.closest('a[href$="/cart"]');
  if (cartLink) {
    e.preventDefault();

    if (window.cartDrawer) {
      window.cartDrawer.render();
      window.cartDrawer.open();
    }
  }
});

window.addEventListener('popstate', function(event) {
    if (window.cartDrawer) {
        window.cartDrawer.close();
    }
});
document.addEventListener('submit', function(e) {

  if (e.target.matches('form[action$="/cart/add"]')) {
    e.preventDefault();
    const formData = new FormData(e.target);
    fetch('/cart/add.js', {
      method: 'POST',
      body: formData
    })
    .then(() => {
      window.cartDrawer.render();
      window.cartDrawer.open();
    });
  }

});
